import { Helmet } from "react-helmet-async";

const SITE_URL = "https://santusgastroenterologo.it";

export default function SEO({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd,
}) {
  const fullTitle = title
    ? `${title} · Dr. Cristian Santus`
    : "Dr. Cristian Santus · Gastroenterologo — Portoscuso e Cagliari";
  const canonical = `${SITE_URL}${path}`;
  const desc =
    description ||
    "Dr. Cristian Santus, gastroenterologo in Sardegna. Visite specialistiche, second opinion e percorsi di cura personalizzati a Portoscuso e Cagliari.";
  const ogImage =
    image ||
    "https://customer-assets.emergentagent.com/job_elite-gastro-santus/artifacts/fwop9lov_Foto_Profilo_Lavoro.png";

  return (
    <Helmet>
      <html lang="it" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content="Dr. Cristian Santus" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="author" content="Dr. Cristian Santus" />
      <meta name="geo.region" content="IT-88" />
      <meta name="geo.placename" content="Cagliari, Portoscuso" />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
